import FieldSet from '../../FieldSet';
import { RiskTag } from './RiskTag';
import { RiskWarningIcon } from './RiskWarningIcon';
import { TimeInTeamStatus } from './TimeInTeamStatus';

export class DeliveryRisksFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [RiskTag, RiskWarningIcon, TimeInTeamStatus];
  }

  get title() {
    return 'Delivery risks';
  }
}
